import $ from 'jquery';

if ($('body .feedback__question').length) {
    const feedbackButtons = $('.feedback__buttons button');
    const feedbackFormWrapper = $('.feedback__form');
    const loadingSpinner = $('.loading-data');

    // eslint-disable-next-line no-inner-declarations
    function disableButtons() {
        Array.from(feedbackButtons).forEach((el) => {
            el.setAttribute('disabled', true);
        });
    }

    /* show form when user clicks feedback buttons */
    feedbackButtons.each(function () {
        $(this).on('click', function () {
            const clickedButton = $(this);
            const isDisabled = clickedButton.attr('disabled');
            if (!isDisabled) {
                const ratingValue = clickedButton.attr('data-rating');
                // Store the rating response in the hidden field. This is used by the form #981686 to display results on the csv report
                $('#q981687_q8').val(ratingValue);
            }
            const $buttonParent = clickedButton.closest('.feedback__wrapper');

            const isButtonActive = clickedButton.hasClass('active');
            $buttonParent.find('.active').removeClass('active');
            clickedButton.toggleClass('active', !isButtonActive);

            const isAnyButtonActive = $buttonParent
                .find('.active')
                .hasClass('active');
            feedbackFormWrapper.toggleClass('hidden', !isAnyButtonActive);
        });
    });

    // Array.from(feedbackButtons).forEach((el) => {
    // el.addEventListener('click', () => {
    //     if (feedbackFormWrapper.hasClass('hidden')) {
    //         console.log('kkk', el);
    //         el.addClass('active');
    //         feedbackFormWrapper.removeClass('hidden');
    //     } else {
    //         feedbackFormWrapper.addClass('hidden');
    //     }
    //     // disableButtons();
    // });
    // });

    // eslint-disable-next-line no-inner-declarations
    function submitFeedbackForm(event) {
        event.preventDefault();
        const $form = $(event.target);
        const $formWrapper = $form.parent();
        const actionUrl = `${$form.prop('action')}&SQ_ASSET_CONTENTS_RAW`;
        // eslint-disable-next-line no-undef
        const formData = new FormData($form[0]);

        // submit button
        // const $submitButton = $form.find('.sq-form-submit');

        // As this not using the out of the box matrix input field
        // Have to manually add submit value so that Matrix can submit successfully
        const formId = $form.prop('id');
        const submitInputValue = `${formId}_submit`;
        formData.append(submitInputValue, 'Submit');

        // Get ready to post form data
        // eslint-disable-next-line no-undef
        const xhr = new XMLHttpRequest();
        xhr.open('POST', actionUrl);

        // eslint-disable-next-line func-names
        xhr.onload = function () {
            // Remove form that was just submitted
            $form.remove();
            loadingSpinner.removeClass('hidden');
            // A 200 response doesn't mean the form was submitted successfully.
            // There might be server validation issues
            // Check if the response contains a form tag or not
            // No form tag means its successful
            if (this.readyState === 4 && this.status === 200) {
                const $response = $(this.response);
                // If no form tag in response, its a success
                if (!$response.is('form')) {
                    loadingSpinner.addClass('hidden');
                    // Show success message that was hidden by CSS on page load
                    $formWrapper.append('<p>Thank you for your feedback.</p>');
                    // disable feedback buttons once form is successfully submitted
                    disableButtons();
                    // Scroll instantly to top of feedback wrapper
                    const feedbackWrapperOffsetTop = $(
                        '.feedback__question'
                    ).offset().top;
                    document.documentElement.scrollTop =
                        feedbackWrapperOffsetTop;
                } else {
                    loadingSpinner.addClass('hidden');
                    // Append form with errors response
                    $formWrapper.append($response);
                    // Scroll instantly to top of form wrapper
                    const formWrapperOffsetTop = $formWrapper.offset().top;
                    document.documentElement.scrollTop = formWrapperOffsetTop;
                }
            } else {
                loadingSpinner.addClass('hidden');
                $formWrapper.append(
                    '<p>Something went wrong. Please refresh the page and try again.</p>'
                );
            }
        };

        xhr.send(formData);
    }

    $('body').on('submit', '.custom-form--feedback', submitFeedbackForm);
}
